import React from 'react';
import { motion } from 'framer-motion';
import { BookIcon, JournalIcon, ListIcon, KitchenIcon, JointIcon, SparkleIcon } from './icons';
export const Offer: React.FC = () => {
  const bonuses = [{
    icon: JournalIcon,
    name: '30-Day Recipe Journal',
    desc: 'Exactly what to cook and how to track vitality.',
    val: '$97'
  }, {
    icon: ListIcon,
    name: 'The Toxic Blacklist',
    desc: 'Brands and ingredients to ban from your home.',
    val: '$47'
  }, {
    icon: ListIcon,
    name: 'The Costco Shopping Guide',
    desc: 'Bulk buying secrets for longevity.',
    val: '$37'
  }, {
    icon: KitchenIcon,
    name: 'Cancer-Proof Kitchen',
    desc: 'Targeted nutrients to starve tumor cells.',
    val: '$67'
  }, {
    icon: JointIcon,
    name: 'Joint Mobility Protocol',
    desc: 'Reversing arthritis naturally.',
    val: '$47'
  }];
  return <section className="py-20 px-6 sm:px-8 lg:px-12 max-w-6xl mx-auto border-t border-gold/30" data-id="element-178">
      <div className="text-center mb-16" data-id="element-179">
        <span className="text-xs font-bold tracking-[0.2em] text-gold uppercase block mb-4" data-id="element-180">
          Introducing
        </span>
        <h2 className="font-serif text-4xl sm:text-5xl text-forest-dark" data-id="element-181">
          The Longevity Dog Ecosystem
        </h2>
      </div>

      <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-183">
          <img src="https://cdn.magicpatterns.com/uploads/6pDetBawJHEv8Arcf32RXw/Mockup.png" alt="The Longevity Dog Book and Digital Devices Mockup" className="w-full h-auto rounded-xl shadow-2xl border border-gold/20" data-id="element-184" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6" data-id="element-185">
          {/* Main Product */}
          <div className="bg-white p-6 rounded-xl border-2 border-forest shadow-md flex gap-4 items-start" data-id="element-186">
            <div className="bg-forest/10 p-3 rounded-lg shrink-0" data-id="element-187">
              <BookIcon className="w-6 h-6 text-forest" data-id="element-188" />
            </div>
            <div className="flex-grow" data-id="element-189">
              <div className="flex justify-between items-start mb-1" data-id="element-190">
                <h3 className="font-serif font-bold text-xl text-forest-dark" data-id="element-191">
                  The Longevity Dog Blueprint
                </h3>
                <span className="text-sm font-bold text-gold" data-id="element-192">Value $197</span>
              </div>
              <p className="text-sm text-charcoal/70" data-id="element-193">
                The 10-minute science-based protocol for life extension.
              </p>
            </div>
          </div>

          {/* Bonuses */}
          <div className="space-y-3" data-id="element-194">
            {bonuses.map((bonus, i) => <div key={i} className="bg-cream-light p-4 rounded-lg border border-gold/20 flex gap-4 items-center" data-id="element-195">
                <div className="bg-gold/10 p-2 rounded shrink-0" data-id="element-196">
                  <bonus.icon className="w-5 h-5 text-gold-dark" data-id="element-197" />
                </div>
                <div className="flex-grow" data-id="element-198">
                  <div className="flex justify-between items-center" data-id="element-199">
                    <h4 className="font-bold text-sm text-charcoal" data-id="element-200">
                      {bonus.name}
                    </h4>
                    <span className="text-xs font-bold text-gold-dark" data-id="element-201">
                      Value {bonus.val}
                    </span>
                  </div>
                  <p className="text-xs text-charcoal/60 mt-0.5" data-id="element-202">
                    {bonus.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="bg-forest/5 p-4 rounded-lg border border-forest/10 flex items-center justify-center gap-2" data-id="element-203">
            <SparkleIcon className="w-4 h-4 text-forest" data-id="element-204" />
            <span className="text-sm font-bold text-forest-dark uppercase tracking-wide" data-id="element-205">
              + 10 More Exclusive Bonuses!
            </span>
          </div>

          <div className="pt-6 border-t border-gold/30 text-center" data-id="element-206">
            <div className="mb-2" data-id="element-207">
              <span className="text-charcoal/50 font-bold uppercase tracking-wider text-sm mr-3" data-id="element-208">
                Total Value:
              </span>
              <span className="text-charcoal/40 line-through text-lg font-serif" data-id="element-209">
                $557
              </span>
            </div>
            <div className="mb-8" data-id="element-210">
              <span className="text-forest-dark font-bold uppercase tracking-wider text-sm block mb-1" data-id="element-211">
                Get It All Today For Only
              </span>
              <span className="text-5xl font-serif font-bold text-gold-dark" data-id="element-212">
                $37
              </span>
            </div>

            <button className="w-full bg-forest hover:bg-forest-dark text-cream font-bold text-lg px-8 py-4 rounded shadow-lg transition-all hover:-translate-y-0.5" data-id="element-213">
              CLAIM THE FULL ECOSYSTEM NOW
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
};